module.exports = __webpack_public_path__ + "img/slide-2.30c41fe3.jpg";